var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBugLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 500,
    height: 500,
    className: "illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#69d7f9;}.cls-2{fill:none;stroke:#3a00ba;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.77,17.13s6.38,1.14,6.38,8.83h5.56V20.89S83.73,17.13,72.77,17.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.64,28.91V65.24c0,4.41-.82,10.14-8.84,10.14H81.6s3.6-1.14,3.6-4.42V28.74l-5.56-.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.71,48.54s-1.47,7-5.73,10-10.47,1-10.47,1l8.18,5.73,9.66-5.57L60,48.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.09,38.73s-.16,4.91-5.07,4.74l4.42,2.13,2.62-3.93Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.8,22.22v3.56H15.21V22.25a4.92,4.92,0,0,1,4.93-4.93h59.7A4.93,4.93,0,0,1,84.8,22.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.2,71.33a4.4,4.4,0,0,0,4.4,4.39H80.4a4.4,4.4,0,0,0,4.4-4.39V28.74H15.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.65,
    y1: 21.76,
    x2: 22.52,
    y2: 21.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 24.01,
    y1: 21.76,
    x2: 27.88,
    y2: 21.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.38,
    y1: 21.76,
    x2: 33.25,
    y2: 21.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "59.59 41.24 63.84 36.98 78.57 36.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 65.48,
    y1: 40.58,
    x2: 78.13,
    y2: 40.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "36.27 61.58 33.38 64.47 20.51 64.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.75,
    y1: 60.87,
    x2: 20.51,
    y2: 60.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "53.92 45.96 56.4 41.67 53.2 36.13 46.81 36.13 43.61 41.67 46.08 45.95"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 47.99,
    y1: 38.65,
    x2: 47.99,
    y2: 40.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 52.02,
    y1: 38.65,
    x2: 52.02,
    y2: 40.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.38 59.94 59.38 49.11 50 43.69 40.63 49.11 40.63 59.94 50 65.35 59.38 59.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "56.49 59.08 61.77 59.26 59.05 68.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "44.81 48.98 42.51 44.23 33.61 48.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "55.2 48.98 57.5 44.23 66.4 48.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "55.66 55.83 59.39 52.09 66.38 59.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "44.35 54.57 40.62 50.84 33.63 57.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "43.52 59.08 38.24 59.26 40.96 68.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 47.7,
    y1: 61.16,
    x2: 52.31,
    y2: 61.16
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugLine);
export default __webpack_public_path__ + "static/media/Bug_Line.3a24744cee8ec1049808c566bdeb0679.svg";
export { ForwardRef as ReactComponent };